import { render, staticRenderFns } from "./PVolumeWidget.vue?vue&type=template&id=13e579e3&scoped=true"
import script from "./PVolumeWidget.vue?vue&type=script&lang=js"
export * from "./PVolumeWidget.vue?vue&type=script&lang=js"
import style0 from "./PVolumeWidget.vue?vue&type=style&index=0&id=13e579e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e579e3",
  null
  
)

export default component.exports